import { render, staticRenderFns } from "./tenant.vue?vue&type=template&id=8532a9e0&"
import script from "./tenant.vue?vue&type=script&lang=js&"
export * from "./tenant.vue?vue&type=script&lang=js&"
import style0 from "./tenant.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports